import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { Stack, Typography } from '@mui/material';
import { Variant } from '@mui/material/styles/createTypography';

interface Props {
  label: string;
  isOrigin?: boolean;
  py?: number;
  px?: number;
  titleVariant?: Variant;
  subtitleVariant?: Variant;
}

export const TravelPointLabel = ({
  label,
  isOrigin = false,
  py = 1,
  px = 4,
  titleVariant = 'body2',
  subtitleVariant = 'caption',
}: Props) => {
  const { t } = useTranslation();

  return (
    <Stack
      py={py}
      px={px}
      border="1px solid rgba(186, 186, 186, 0.30)"
      bgcolor="#FEFEFE"
      minWidth={120}
      minHeight={50}
      direction="column"
      alignItems="center"
      borderRadius="8px"
    >
      <Typography color="primary" variant={titleVariant} fontWeight={700} lineHeight="16px">
        {t(label)}
      </Typography>
      <Typography color="secondary.contrastText" variant={subtitleVariant} fontWeight={700} lineHeight="16px">
        {isOrigin ? t('inputs.origin') : t('inputs.destination')}
      </Typography>
    </Stack>
  );
};
